import template from "./final_residual_count_commit.html";
import controller from "./final_residual_count_commit.controller";
import "./final_residual_count_commit.scss";

let branchManagementFinalResidualCountCommitComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementFinalResidualCountCommitComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/final_residual_count_commit/final_residual_count_commit.component.js